import * as actionTypes from './actionTypes';
import firebase from '../../firebase';
import { setMessages } from './actionNotifications';


export const getUsers = () => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Users' ).get()
            .then( users => {
                const userList = {};
                users.forEach( user => {
                    userList[ user.id ] = user.data();
                } );
                dispatch( usersFound( userList ) );
            } ).catch( err => {
                console.log( 'Error getting users', err );
            } )
    }
}

const usersFound = ( userList ) => {
    return {
        type: actionTypes.USERS_FOUND,
        userList: userList
    }
}

export const updateAuthState = ( id ) => {
    return dispatch => {
        const db = firebase.firestore();
        if( firebase.auth().currentUser ) {
            db.collection( 'Users' ).doc( id ).get()
                .then( ( user ) => {
                    dispatch( authSuccess( user.data(), user.id ) );
                    dispatch( checkEmailVerified() )
                } ).catch( err => {
                    console.log( 'Error finding user', err );
                } )

        }
    }
}

//Use for updating signed in user
export const updateUser = ( user, id ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Users' ).doc( id ).update( user )
            .then( () => {
                dispatch( authSuccess( user, id ) );
            } ).catch( err => {
                console.log( 'Error getting documnet ', err );
            } );
    }
}

const updateUserListState = ( user, id ) => {
    return {
        type: actionTypes.UPDATE_USER_LIST,
        user: user,
        id: id
    }
}

//Use for updating users through the staff portal
export const updateUserDatabase = ( user, id ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Users' ).doc( id ).update( user )
            .then( () => {
                dispatch( setMessages( user.name + ' Updated', 'success' ) );
                dispatch( updateUserListState( user, id ) );
            } ).catch( err => {
                dispatch( setMessages( "Couldn't update " + user.name, 'error' ) );
            } )
    }
}

export const deleteUser = ( id ) => {
    return dispatch => {
        const db = firebase.firestore();
        db.collection( 'Users' ).doc( id ).delete()
            .then( () => {
                //dispatch(getUsers());
                console.log( 'deleted' );
            } ).catch( err => {
                console.log( 'Error Deleting ', err );
            } );
    }
}

export const createFirebaseUser = ( user, password ) => {
    return dispatch => {
        const db = firebase.firestore();
        firebase.auth().createUserWithEmailAndPassword( user.email, password )
            .then( ( resp ) => {
                return db.collection( 'Users' ).doc( resp.user.uid ).set( user ).then( () => {
                    db.collection( 'Users' ).doc( resp.user.uid ).get()
                        .then( ( user ) => {
                            //console.log(user.data());
                            //console.log(user.id);
                            dispatch( setMessages( 'Successfully created User' ) );
                            dispatch( authSuccess( user.data(), user.id ) );
                            dispatch( sendEmailVerificationLink() );
                        } );
                } ).catch( ( err ) => {
                    dispatch( setMessages( err, 'error' ) )
                    console.log( 'Error adding user to database ', err );
                } )
            } ).catch( ( err ) => {
                dispatch( setMessages( err, 'error' ) )
                console.log( 'Error creating new user ', err );
            } );
    }
}

const authSuccess = ( user, id ) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        user: user,
        id: id,
    }
}

const checkEmailVerified = () => {
    let emailVerified = firebase.auth().currentUser.emailVerified;
    let type = emailVerified ? actionTypes.EMAIL_VERIFIED : actionTypes.EMAIL_NOT_VERIFIED;
    return {
        type: type
    }
}

export const signInFireBaseUser = ( email, password ) => {
    const db = firebase.firestore();
    return dispatch => {
        firebase.auth().signInWithEmailAndPassword( email, password )
            .then( resp => {
                //console.log(resp.user.uid);
                db.collection( 'Users' ).doc( resp.user.uid ).get()
                    .then( ( user ) => {
                        //console.log(user.data());
                        //console.log(user.id);
                        dispatch( setMessages( 'Successfully Signed In' ) );
                        dispatch( authSuccess( user.data(), user.id ) );
                        dispatch( checkEmailVerified() )
                    } );
            } ).catch( err => {
                console.log( "Error Logging in ", err );
            } )
    }
};

const logOut = () => {
    return {
        type: actionTypes.LOGOUT
    }
}

export const manualLogOut = () => {
    return dispatch => {
        firebase.auth().signOut()
            .then( () => {
                dispatch( logOut() );
                dispatch( setMessages( 'Successfully logged out' ) );
            } ).catch( ( err ) => {
                console.log( 'Error Logging out ', err );
            } )

    }
}

//GOOGLE SIGN IN
export const googleSignIn = () => {
    const db = firebase.firestore();
    let provider = new firebase.auth.GoogleAuthProvider();
    return dispatch => {
        firebase.auth().signInWithPopup( provider )
            .then( ( resp ) => {
                //let token = resp.credential.accessToken;
                let user = resp.user;
                db.collection( 'Users' ).doc( user.uid ).get()
                    .then( ( data ) => {
                        //Log In User
                        if( data.exists ) {
                            dispatch( setMessages( 'Successfully Logged in' ) );
                            dispatch( authSuccess( data.data(), user.uid ) );
                            dispatch( checkEmailVerified() );
                        } else {
                            // Create new user database
                            db.collection( 'Users' ).doc( user.uid ).set( {
                                name: user.displayName,
                                email: user.email,
                                savedStarMaps: [],
                                myStarMaps: [],
                                lastLogin: new Date()
                            } ).then( () => {
                                dispatch( setMessages( 'Successfully created User' ) );
                                dispatch( authSuccess( { name: user.displayName, email: user.email, savedStarMaps: [], myStarMaps: [] }, user.uid ) );
                                dispatch( checkEmailVerified() );
                            } ).catch( ( err ) => {
                                console.log( 'Error adding user to database ', err );
                            } );
                        }
                    } )
            } ).catch( ( err ) => {
                console.log( err.code, ' ', err.message );
            } )
    }
}


//EMAIL VERIFICATION
export const sendEmailVerificationLink = () => {
    let currentUser = firebase.auth().currentUser;
    return dispatch => {
        currentUser.sendEmailVerification()
            .then( function () {
                // Verification email sent.
                dispatch( setMessages( `Email Link Sent to ${currentUser.email}` ) );
            } )
            .catch( ( err ) => {
                dispatch( setMessages( 'Too many send requests please try again later' ) );
                console.log( 'Problem sending email ', err );
            } );
    }
}